export enum MaritalStatus {
  Solteiro = 'Solteiro',
  Casado = 'Casado',
  Divorciado = 'Divorciado',
  Viuvo = 'Viuvo'
  }
